import axios from 'axios';
import ServiceUserAccount from '../@types/service-user-account';
import {API_URL, MEDIA_TYPE_V2} from '../config/constants';
import { makeServiceUserAccount } from '../utils/service-user-account-utils';
import {getErrorMessage} from '../utils/utils';
import SpringDataPage, {BasicPage} from '../@types/spring-data-page';

export class ServiceUserAccountService {
    static serviceUserUrlV1 = API_URL + 'serviceUsers';
    static serviceUserUrlV2 = API_URL + 'api/v2/serviceUsers';

    formServiceUserAccount(serviceUserAccount: any): ServiceUserAccount {
        return makeServiceUserAccount(serviceUserAccount);
    }

    formServiceUsersPagePromise(serviceUsersData: any): Promise<SpringDataPage<ServiceUserAccount>> {
        let serviceUsersPage: SpringDataPage<ServiceUserAccount> = {} as SpringDataPage<ServiceUserAccount>;
        if (serviceUsersData) {
            if (serviceUsersData._embedded?.isamServiceUserDTOList) {
                serviceUsersPage.content = serviceUsersData._embedded.isamServiceUserDTOList?.map((serviceUserAccount: any) => this.formServiceUserAccount(serviceUserAccount));
            } else {
                serviceUsersPage.content = [];
            }
            serviceUsersPage.page = serviceUsersData.page;
        }
        return Promise.resolve(serviceUsersPage);
    }

    createServiceUser(serviceUser: ServiceUserAccount): Promise<ServiceUserAccount> {
        return axios.post(ServiceUserAccountService.serviceUserUrlV2, serviceUser, {
            withCredentials: true,
            headers: { 'Content-Type': 'application/json' }
        }).then((response: any) => {
            return this.formServiceUserAccount(response.data);
        }).catch((error: any) => {
            throw new Error(error.response.data?.description ?? 'Create service user failed with error: ' + error.message);
        });
    }

    deleteUserById(id: number): Promise<void> {
        return axios.delete(ServiceUserAccountService.serviceUserUrlV2 + '/' + id, {
            withCredentials: true,
            headers: { 'Content-Type': MEDIA_TYPE_V2 },
        }).then(() => {
            return;
        }).catch((error: any) => {
            throw new Error(`Delete service user ${id} failed with error: ` + getErrorMessage(error));
        });
    }

    getServiceUserById(id: number): Promise<ServiceUserAccount> {
        return axios.get(ServiceUserAccountService.serviceUserUrlV2 + '/' + id, {
            withCredentials: true,
            headers: { 'Content-Type': MEDIA_TYPE_V2 },
        }).then((response: any) => {
            return this.formServiceUserAccount(response.data);
        }).catch((error: any) => {
            throw new Error(`Get service user ${id} returned an error: ` + getErrorMessage(error));
        });
    }

    reissueServiceUserKey(serviceUser: ServiceUserAccount): Promise<ServiceUserAccount> {
        return axios.post(ServiceUserAccountService.serviceUserUrlV2 + '/' + serviceUser.id + '/reissueApiKey', {}, {
            withCredentials: true,
            headers: { 'Content-Type': MEDIA_TYPE_V2 },
        }).then((response: any) => {
            return this.formServiceUserAccount(response.data);
        }).catch((error: any) => {
            throw new Error(`Reissue API Key for service user ${serviceUser.id} failed with error: ` + getErrorMessage(error));
        });
    }

    getPagedServiceUsers(page: BasicPage, isActive: boolean|null, searchTerm?: string): Promise<SpringDataPage<ServiceUserAccount>> {
        let url = `${ServiceUserAccountService.serviceUserUrlV2}?`
            + `size=${page.size}&`
            + `page=${page.offset}&`
            + `sort=${page.sort},${page.direction}`;
        if (searchTerm && searchTerm !== '') url += `&searchTerm=${searchTerm}`;
        if (isActive !== null) url += `&isActive=${isActive}`;
        return axios
            .get(url, {
                withCredentials: true,
                headers: { 'Content-Type': 'application/hal+json' }
            })
            .then(response => {
                return this.formServiceUsersPagePromise(response.data);
            })
            .catch(err => {
                throw new Error('Failed to get paged users: ' + getErrorMessage(err));
            })
    }

}

export default new ServiceUserAccountService();
